import { Flex } from 'antd';
import styled from 'styled-components';

export const Section = styled(Flex)`
  padding: 24px;
  background: #fff;
`;

export const SectionTitle = styled.p`
  margin: 0;
  line-height: 24px;
  font-size: 18px;
  font-weight: 500;
  color: ${(props) => props.theme.antd?.colorPrimary};
`;
